import Navbar from "./components/navbar/navbar"; 
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import './app.css'
import Home from "./pages/home/home";
import About from "./pages/about/about";
import Contact from "./pages/contect/contect";
import Projects from "./pages/project/project";
import Footer from "./components/footer/footer";

import { useSelector } from 'react-redux'



function App() {
  const cart=useSelector(state=>state.cart)
  console.log(cart)
  return (<div className={cart===true?"darkTheme":"whiteTheme"} id="app"> 
    <Router> <Navbar /> 
    <Routes>
    <Route path="" element={<Home />} />
    <Route path="about" element={<About />} />
    <Route path="project" element={<Projects />} />
    <Route path="contect" element={<Contact />} />
    </Routes>
    <Footer/>
    </Router>
    </div>
  );
  }

export default App;



